import { Component } from '@angular/core';

import { ClaimEnterpriseService } from '@amfam/claim/enterprise/data-access';
import { ChangeCoverageFeatureFacade } from '@amfam/policy/change-coverage/feature';

@Component({
  selector: 'ds-claim-help',
  templateUrl: './claim-help.component.html',
  styleUrls: ['./claim-help.component.scss'],
  standalone: false
})
export class ClaimHelpComponent {
  routePath: string;
  errorBtnText: string;
  constructor(
    public changeCoverageFeatureFacade: ChangeCoverageFeatureFacade,
    private claimEnterpriseService: ClaimEnterpriseService
  ) {
    this.routePath = this.claimEnterpriseService.errorPageRedirectPath || '/overview';
    this.errorBtnText = this.claimEnterpriseService.errorPageRedirectBtnText || 'Back to Overview';
  }
}
